// Frontend mirror of backend bands.py RE_BANDS / VEH_BANDS (key, label, lo, hi).
// Used to deep-link a listing to its Market Intelligence price band.
export const RE_BANDS = [
  ["re1", "$1M – $3M", 1_000_000, 3_000_000],
  ["re2", "$3M – $5M", 3_000_000, 5_000_000],
  ["re3", "$5M – $10M", 5_000_000, 10_000_000],
  ["re4", "$10M – $20M", 10_000_000, 20_000_000],
  ["re5", "$20M – $50M", 20_000_000, 50_000_000],
  ["re6", "$50M+", 50_000_000, null],
];

export const VEH_BANDS = [
  ["v1", "$150K – $300K", 150_000, 300_000],
  ["v2", "$300K – $500K", 300_000, 500_000],
  ["v3", "$500K – $1M", 500_000, 1_000_000],
  ["v4", "$1M – $3M", 1_000_000, 3_000_000],
  ["v5", "$3M+", 3_000_000, null],
];

export function bandForPrice(kind, price) {
  if (price == null) return null;
  const bands = kind === "veh" ? VEH_BANDS : RE_BANDS;
  for (const [key, label, lo, hi] of bands) {
    if (price >= lo && (hi == null || price < hi)) return { key, label };
  }
  return null;
}
